export enum FormIgnoredElements {
  Helper = 9,
  Title = 13,
  Form_Edit = 14,
  Partial_Function = 16,
  Espaciador = 98,
}
